import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import Login from "./pages/login";
import Dashboard from "./pages/dashboard";
import { useEffect, useState } from "react";
import "./App.css";
import NotifyButton from "./pages/modules/calls/call";
import QRCodeGenerator from "./pages/modules/calls/qr_generator";
import { makeRequest } from "./assets/functions_helper";
import { Box, CircularProgress, Backdrop } from "@mui/material";
import ForgotPassword from "./pages/forgotPassword";
import ResetPassword from "./pages/resetPassword";
import TawkToWidget from "./components/tawlkto";
import MenuClients from "./pages/modules/calls/menu_clients/menu_clients";
import Register from "./pages/modules/registration/register";
import VerifyEmail from "./pages/modules/registration/verifyRegister";
import MenuDisplay from "./pages/modules/calls/menu_clients/menu_display";
import PublicLinktree from "./pages/modules/linktree/public_linktree";
import ActiveSurveyView from "./pages/modules/surveys/active_survey_view";
import MenuDelivery from "./pages/modules/calls/menu_delivery/menu_delivery";
import { PaymentSuccess, PaymentCancel } from "./pages/modules/planes/payment_result_pages";
import PublicReservation from "./pages/modules/reservations/public_reservation";
import TransferFlow from "./pages/TransferFlow";

function GlobalLoader() {
  const [activeRequests, setActiveRequests] = useState(0);

  useEffect(() => {
    const handleStart = () => setActiveRequests((prev) => prev + 1);
    const handleEnd = () => setActiveRequests((prev) => Math.max(0, prev - 1));

    window.addEventListener("makeRequestStart", handleStart);
    window.addEventListener("makeRequestEnd", handleEnd);

    return () => {
      window.removeEventListener("makeRequestStart", handleStart);
      window.removeEventListener("makeRequestEnd", handleEnd);
    };
  }, []);

  return (
    <Backdrop
      sx={{
        color: '#fff',
        zIndex: 99999,
        display: 'flex', flexDirection: 'column', gap: 2
      }}
      open={activeRequests > 0}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}

function RoutesComponent({ isLoggedIn, setIsLoggedIn }) {
  return (
    <Routes>
      <Route path="/clientes/:tableNumber" element={<NotifyButton />} />
      <Route path="/restaurantMenu/:tableNumber" element={<MenuClients />} />
      <Route path="/restaurantMenuDisplay/:tableNumber" element={<MenuDisplay />} />
      <Route path="/qr_generate/:tableNumber" element={<QRCodeGenerator />} />
      <Route path="/delivery/:restaurant_id" element={<MenuDelivery />} />
      <Route path="/forgotPassword" element={<ForgotPassword />} />
      <Route path="/reset_password/:token" element={<ResetPassword />} />
      <Route path="/register" element={<Register setIsLoggedIn={setIsLoggedIn} />} />
      <Route path="/register/:verify_key" element={<VerifyEmail />} />
      <Route path="/linktree/:publicId" element={<PublicLinktree />} />
      <Route path="/survey" element={<ActiveSurveyView />} />
      <Route path="/plans/sucess" element={<PaymentSuccess />} />
      <Route path="/plans/success" element={<PaymentSuccess />} />
      <Route path="/plans/cancel" element={<PaymentCancel />} />
      <Route path="/plans/error" element={<PaymentCancel />} />
      <Route path="/reserve/:restaurant_public_id" element={<PublicReservation />} />
      <Route
        path="/transfer"
        element={
          isLoggedIn ? (
            <TransferFlow />
          ) : (
            <Navigate to="/login" />
          )
        }
      />
      <Route
        path="/login"
        element={
          isLoggedIn ? (
            <Navigate to="/" />
          ) : (
            <Login setIsLoggedIn={setIsLoggedIn} />

          )
        }
      />
      <Route
        path="/"
        element={
          isLoggedIn ? (
            <Dashboard setIsLoggedIn={setIsLoggedIn} />
          ) : (
            <Navigate to="/login" />
          )
        }
      />
    </Routes>
  );
}

function App() {
  const [cargando, setCargando] = useState(true);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const tokenType = localStorage.getItem("tokenType");

    // Si no hay token o es un string inválido, el usuario no está autenticado
    if (!token || token === "null" || token === "undefined" || token === "") {
      localStorage.removeItem("token");
      localStorage.removeItem("tokenType");
      setCargando(false);
      return;
    }

    // Comprobar si estamos en una ruta pública que no requiere validación de auth inicial
    // para no ensuciar la red ni llamar al auth del backend innecesariamente.
    const publicPaths = [
      "/restaurantMenu/",
      "/clientes/",
      "/restaurantMenuDisplay/",
      "/qr_generate/",
      "/delivery/",
      "/linktree/",
      "/reserve/",
      "/survey"
    ];

    const isPublicPath = publicPaths.some(p => window.location.pathname.startsWith(p));

    if (isPublicPath) {
      // Estamos en una vista pública de cliente. No validamos auth.
      setCargando(false);
      return;
    }

    makeRequest(
      "GET",
      "users/validate_auth",
      null,
      "application/json",
      token,
      tokenType,
      // Callback seguro: no redirigir con window.location.href aquí.
      // El evento "sessionExpired" ya pone isLoggedIn=false y el router
      // redirige limpiamente a /login sin recargar la página.
      () => { setCargando(false); }
    )
      .then((response) => {
        setIsLoggedIn(true);
        setCargando(false);
      })
      .catch((error) => {
        console.log(error);
        setCargando(false);
      });
  }, [setIsLoggedIn]);


  // Escuchar el evento global de sesión expirada (disparado desde functions_helper.js)
  // para cualquier petición autenticada que falle incluso estando dentro del dashboard
  useEffect(() => {
    const handleSessionExpired = () => {
      setIsLoggedIn(false);
    };

    window.addEventListener("sessionExpired", handleSessionExpired);
    return () => {
      window.removeEventListener("sessionExpired", handleSessionExpired);
    };
  }, []);

  useEffect(() => {
    const checkVersion = async () => {
      try {
        const res = await fetch('/version.json', { cache: 'no-store' });
        const data = await res.json();
        const currentVersion = localStorage.getItem('app-version');

        if (currentVersion && currentVersion !== data.version.toString()) {
          window.location.reload(); // New version found → reload
        }

        localStorage.setItem('app-version', data.version.toString());
      } catch (err) {
        console.error('Version check failed', err);
      }
    };

    const interval = setInterval(checkVersion, 30000);
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      {cargando ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <Router>
          <RoutesComponent
            isLoggedIn={isLoggedIn}
            setIsLoggedIn={setIsLoggedIn}
          />
          <TawkToWidget />
        </Router>
      )}
      <GlobalLoader />
    </>
  );
}

export default App;
